import {useTranslation} from 'react-i18next';
import PlayIcon from '../../../assets/images/play-mt-icon.svg';
import {badgeUrl, limitOverview} from '../../../lib/utils';
import MeetingCalendar from '../../common/MeetingCalendar';
// import UnEnrollUser from './UnEnrollUser';
import defaultImg from '/src/assets/images/default-image-library.png';
import { Button } from "alm-react-components";
import accordionArrowImg from "../../../assets/images/svgicons/accordion-arrow.svg";
import { useNavigate } from 'react-router-dom';

type CourseDetailProps = {
  programDetailObject: any;
  playVideo: (id: string) => void;
  jobAids: any | undefined;
  userEnrollmentId: any;
  programStart: any;
  badgeDetailData: any;
  isAllProgramCompleted?: boolean;
  badgeData:any;
  introductionVideo?:any;
  currentQuarterStartDate: string;
  userEnrollmentDate: string;
  nextQuarterStartDate: string;
};
export const ProgramIntroContent: React.FC<CourseDetailProps> = ({
  programDetailObject,
  playVideo,
  jobAids,
  // userEnrollmentId,
  // programStart,
  badgeData,
  // userEnrollmentDate,
  // currentQuarterStartDate,
  // nextQuarterStartDate
}) => {
  const {t} = useTranslation();
  
  const navigate = useNavigate();

  const programDetailPageRedrection =()=>{
    navigate(-1)
  }
  return (
    <section
      className={`bg-blend-multiply bg-cover bg-center`}
      style={{ backgroundImage: programDetailObject?.bannerImage? (`url('${programDetailObject?.bannerImage}')`):( `url(${defaultImg})`) }}
    >
      <div className="lg:px-8 xl:pr-32 xl:pl-32 md:px-8 mx-auto text-center w-[100%] pt-8">
        <div className="flex justify-between align-center flex-wrap flex-col md:flex-row  sm:space-y-5 md:space-y-0 max-md:px-5">
          <Button
              onClick={() => programDetailPageRedrection()}
              variant="default"
              className="dark:bg-fillMidGrayCard w-6 h-6 pl-0 top-0 mr-3 mt-[5px] max-sm:mb-5"
          >
              <img src={accordionArrowImg} alt={" "} className="logo cursor-pointer h-[14px] ml-4 rotate-180" />
          </Button>
          <MeetingCalendar />
{/* Need to hide this till UAT */}
          {/* {userEnrollmentId &&
            isEnrollmentDateAvailable(programStart) &&
            canProgramBeUnenrolled(currentQuarterStartDate, nextQuarterStartDate, userEnrollmentDate) && (
              <UnEnrollUser enrolledProgram={userEnrollmentId} />
            )} */}
        </div>
      </div>

      <div className="lg:px-8 xl:pr-32 xl:pl-32 xl:pt-20 md:py-14 mx-auto py-24 text-center w-[100%] md:px-8 max-md:px-6">
        <h4 className="mb-5 md:mb-3 lg:text-xl xl:text-2xl uppercase font-barlowLight text-left tracking-wider">
          <span dangerouslySetInnerHTML={{ __html: t('Program.text') }} />
        </h4>
        <h4 className="mb-7 md:mb-4 md:text-3xl lg:text-4xl xl:text-6xl font-barlowRegular text-left">
          {programDetailObject?.name}
        </h4>
        <p className="mb-12 text-lg font-opensansRegular lg:text-xl xl:text-2xl text-left lg:w-[40%] md:w-[60%]">
          {limitOverview(programDetailObject?.description)}
        </p>
        <div className="flex items-center justify-between bg-fillMidGrayCard rounded-2xl space-x-5 w-max h-1/2 p-3">
          <div className="relative cursor-pointer" onClick={() => playVideo(jobAids)}>
            <img
              src={programDetailObject?.coverImage}
              alt="Cover image"
              className="w-[80px] h-[60px] rounded"
            />
            <img src={PlayIcon} alt="Play icon" className="absolute center-icon commitment" />
          </div>
          <div className="">
            <p className="text-start text-lg font-barlowSemiBold tracking-wide">
              <span dangerouslySetInnerHTML={{ __html: t('Program.introduction')}} />
            </p>
          </div>
          <img
            className="w-12 h-12 max-sm:w-10 max-sm:h-10 yellow"
            src={badgeUrl(badgeData.relationshipid, badgeData.included)}
            alt="Banner image"
          />
        </div>
      </div>
    </section>
  );
};
